<div class="menu-item">
  @if (!menuItem!.children) {
    <a
      [routerLink]="menuItem?.route"
      (click)="slideMenuService.showed = false"
      class="menu-item__link d-flex align-items-center gap-3 w-100 rounded-2 border-0 fw-medium text-nowrap overflow-hidden"
      [class.menu-item__link--child]="isChild"
      [attr.title]="collapsed ? menuItem!.title : null">
      @if (menuItem!.icon) {
        <span class="menu-item__icon d-flex align-items-center justify-content-center flex-shrink-0">
          <i class="material-icons">{{ menuItem!.icon }}</i>
        </span>
      }
      @if (!collapsed) {
        <span class="menu-item__text flex-grow-1 text-truncate">{{ menuItem!.title }}</span>
      }
    </a>
  }

  @if (menuItem!.children) {
    <button
      (click)="isExpanded = !isExpanded"
      [attr.aria-expanded]="isExpanded"
      class="menu-item__link menu-item__link--parent d-flex align-items-center gap-3 w-100 rounded-2 border-0 fw-medium text-nowrap overflow-hidden text-start"
      [class.menu-item__link--expanded]="isExpanded"
      [attr.title]="collapsed ? menuItem!.title : null"
      type="button">
      @if (menuItem!.icon) {
        <span class="menu-item__icon d-flex align-items-center justify-content-center flex-shrink-0">
          <i class="material-icons">{{ menuItem!.icon }}</i>
        </span>
      }
      @if (!collapsed) {
        <span class="menu-item__text flex-grow-1 text-truncate">{{ menuItem!.title }}</span>
        <i class="material-icons menu-item__arrow ms-auto"
          [class.menu-item__arrow--open]="isExpanded">
          expand_more
        </i>
      }
    </button>

    @if (isExpanded && !collapsed) {
      <div class="menu-item__submenu">
        @for (child of menuItem?.children; track $index) {
          <app-menu-item
            [menuItem]="child"
            [collapsed]="false"
            [isChild]="true">
          </app-menu-item>
        }
      </div>
    }
  }
</div>
